import React,{useState, useEffect} from 'react';
import {Tools} from './Tools';
import "./Dial.scss";

interface Props {
    text:string,
    next():void,
    step:number,
}

interface Pos {
    x: number,
    y: number,
}

let tid:NodeJS.Timeout;

const Dial = (props:Props)=> {
    const defWords:string[] = [];
    const defCircles:Pos[] = [];
    const [states,setStates] = useState({
        selected: "",
        words: defWords,
        circles: defCircles,
        isEnd: false,
        isMiss: false,
        step: 0,
    })

    const choice = (e: React.MouseEvent<HTMLElement>)=>{
        if(! e.currentTarget.dataset.value ){
            return;
        }
        if( states.isMiss || states.isEnd ){
            return;
        }
        const selected = states.selected+e.currentTarget.dataset.value;
        if( selected===props.text ){
            //達成
            setStates({...states,selected:selected,isEnd:true});
            tid = setTimeout( ()=>{
                props.next();
            },300);
        } else if( props.text.substr(0,selected.length)!==selected ) {
            //ミス
            //console.log("miss",selected);
            setStates({...states,isMiss:true});
            tid = setTimeout( ()=>{
                setStates({...states,isMiss:false,selected:""});
            },300);
        } else {
            setStates({...states,selected:selected});
        }
    }

    useEffect( ()=>{
        const words = Tools.shuffle(props.text.trim().split(""));
        const max = words.length;
        const per = Math.PI*2/max;

        let circles = defCircles;
        const st = max*Math.random();
        for( let i=0 ; i<max ; i++ ){
            const angle = per * (i+st);
            const x = Math.floor(40 * Math.cos(angle) * 100)/100;
            const y = Math.floor(40 * Math.sin(angle) * 100)/100;

            circles.push({
                x:x,
                y:y,
            });
        }

        setStates({...states,selected:"",words:words,circles:circles,isEnd:false,isMiss:false,step:props.step});

        return ()=>{
            clearTimeout(tid);
        }
    },[props.text,props.step]);

    if( states.circles.length===0 ){
        return (null);
    }

    return (
        <div id="dial">
            <div className="dialScr">
                {props.text.split("").map((word:string,index:number)=>{
                    const key = "word"+index;
                    let cl = "normal";
                    if( states.selected.substr(index,1)===word ){
                        cl = "correct";
                    }
                    return (
                        <span key={key} className={cl}>{word}</span>
                    )
                })}
            </div>
            <div className="dialBoard">
                <div className="content">
                    {states.circles.map((circle:Pos,index:number)=>{
                        const key = "circle"+index;
                        const x = String(circle.x + 50) + "%"
                        const y = String(circle.y + 50) + "%"
                        const style:React.CSSProperties = {
                            "position":"absolute",
                            "top": y,
                            "left": x,
                        }
                        let cl = "dialBtn";
                        if( states.isEnd ){
                            cl = cl + " fadeout";
                        } else if( states.isMiss ){
                            cl = cl + " miss";
                        } else if(states.selected===""){
                            if( index===0 ){
                                cl = cl + " fadein fadein0";
                            } else {
                                cl = cl + " fadein fadein" + String( Math.floor(10*(index/states.words.length))+1 );
                            }
                        }
                        return (
                            <button className={cl} key={key} style={style} onClick={choice} data-value={states.words[index]}>{states.words[index]}</button>
                        )
                    })}
                </div>
            </div>
        </div>
    );
}

export default Dial;
